import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { historialPoseedorBienCutural } from 'app/modules/admin/bienes-culturales/detalle-bien-cultural/herramientas/models/historial-traspaso-bien-cultural';

@Component({
    selector: 'historial-poseedor',
    templateUrl: 'historial-poseedor.component.html',
    imports:[
        CommonModule,
        MatTableModule,
        MatIconModule
    ]
})

export class HistorialPoseedorComponent implements OnInit {
    @Input() historialPoseedor:historialPoseedorBienCutural[]= []
    columns:any[]= ['coleccionista', 'registroAnterior', 'fecha', 'operadoPor']
    constructor() { }

    ngOnInit() { }
}